import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=54579fde&"
import script from "./EmailConfig.vue?vue&type=script&lang=ts&"
export * from "./EmailConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports